<template>
  <div class="v-page-pro">
    <!-- 头部区域 -->
    <div
      ref="header-container"
      class="header-container"
      :class="[headerTheme, isVivoAppNoOS4]"
      data-html2canvas-ignore="true"
    >
      <div v-show="isShowHeader">
        <div class="status" v-statusBarHeight="'height'"></div>
        <div class="header">
          <div class="icon back" role="button" tabindex="0" aria-label="返回" @click="goBack">
            <v-icon class="icon-back" name="arrow-left-v3"></v-icon>
          </div>
          <!-- <img class="icon" src="./images/left-arrow.png" @click="goBack" /> -->
          <div class="content" :class="{ 'pd-share': isShowShareBtn || showSearchBtn}" @click="toTop">
            <div class="text lc-1">{{ headerText || $route.meta.title || 'vivo商城' }}</div>
          </div>
          <div class="right">
            <!-- todo:这里需要注意左侧只能显示一个icon，如果显示两个icon，需要处理os3标题居中的场景 -->
            <div
              class="icon share"
              v-if="isShowShareBtn"
              @click="doPageShare"
              tabindex="0"
              role="button"
              aria-label="分享"
            >
              <v-icon class="i-share" name="icon-share" v-if="isVivoAppNoOS4"></v-icon>
              <v-icon class="i-share-v2" name="icon-share-v2" v-else></v-icon>
            </div>
            <a
              href="https://www.vivo.com.cn/search/index"
              class="icon search"
              v-if="showSearchBtn"
              v-track="[{ act: 'click', params: { cfrom: 5126, search_page: 3 } }]"
            >
              <v-icon class="icon-search" name="search-v2"></v-icon>
              <!-- <div class="icon-search"></div> -->
            </a>
            <slot v-if="$slots.headerRight" name="headerRight" />
            <div v-else class="icon menu" @click="isShowMenu = !isShowMenu">
              <v-icon class="i-menu" name="icon-menu-v3"></v-icon>
            </div>
            <!-- <img v-else class="icon" src="./images/more.png" alt="" @click="isShowMenu = !isShowMenu" /> -->
          </div>
          <v-header-menu :isShowMenu="isShowMenu" @close="closeMenu"></v-header-menu>
        </div>
      </div>
      <slot v-if="$slots.headerExtra" name="headerExtra" />
    </div>
    <!-- 错误页面 -->
    <div v-if="isShowPageError" class="page-error">
      <v-empty type="error">
        <div class="option btn-group">
          <nx-button @click="retry" type="frame-plus">点击重试</nx-button>
          <nx-button @click="returnHome" type="frame-plus" v-if="showErrorHomeBtn">返回首页</nx-button>
        </div>
      </v-empty>
      <!-- <div class="img"></div>
      <p>{{ errorTitle }}</p>
      <div class="option">
        <a @click="retry">点击重试</a>
        <a :href="`${linkBase}`">返回首页</a>
      </div> -->
    </div>
    <div v-else class="page-container" :style="pageForceHeight">
      <!--是否已经初始化完成-->
      <slot v-if="pageInit" />
      <!--初始化没有完成，显示等待状态，支持sketch-->
      <template v-else>
        <slot v-if="$slots.skeleton" name="skeleton" />
        <v-pending v-else :class="[isLowAndroid ? 'lowAndroid' : '']" />
      </template>
    </div>
  </div>
</template>

<script>
import create from '../create'
import { goBack, debounce } from 'utils/common'
import clientEnv from '@/utils/clientEnv'
import shop from 'utils/shop'
import Stickyfill from 'stickyfilljs'
import { Button } from '@vivo/vos-ui'
import app from 'utils/app'
export default create({
  name: 'page-pro',
  components: {
    [Button.name]: Button
  },
  props: {
    // 是否错误页面
    pageError: {
      type: Boolean,
      default: false
    },
    // 是否完成初始化
    pageInit: {
      type: Boolean,
      default: true
    },
    pageTitle: {
      type: String,
      default: '很抱歉，服务器开小差了~'
    },
    headerText: {
      type: String,
      default: ''
    },
    headerTheme: {
      type: String,
      default: 'light' // light Or dark
    },
    listenScroll: {//监听滚动加载
      type: Boolean,
      default: false
    },
    hideHeader: {
      type: Boolean,
      default: false
    },
    // 特殊页面高度设置（防止header重新计算抖动）
    pageForceHeight: {
      type: String,
      default: ''
    },
    // 是否展示分享按钮
    showShare: {
      type: Boolean,
      default: false
    },
    showSearchBtn: {
      type: Boolean,
      default: false
    },
    // 异常状态是否展示回到首页
    showErrorHomeBtn: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      isShowMenu: false,
      debounce: null,
      isLowAndroid: clientEnv.androidLevel && clientEnv.androidLevel < 8 && clientEnv.isVivoApp
    }
  },
  computed: {
    // 官网app且不是OS4系统
    isVivoAppNoOS4() {
      if (clientEnv.isVivoApp && !clientEnv.isOS4 && !clientEnv.isIOSVivoApp) {
        return 'vivo-app-no-os-4'
      }
      return ''
    },
    // 是否展示分享按钮，仅在官网app内展示
    isShowShareBtn() {
      return this.showShare && clientEnv.isVivoApp && !clientEnv.isIOSVivoApp
    },
    isShowPageError() {
      // 如果全局pageError状态为true，则直接显示错误页，否则，判断page组件pageError状态
      return this.$store.state.pageError || this.pageError
    },
    errorTitle() {
      // 如果全局pageError状态为true，则直接显示错误页，否则，判断page组件pageError状态
      return this.$store.state.pageTitle || this.pageTitle
    },
    isShowHeader() {
      if (this.hideHeader) {
        return false
      }
      if (shop.hidenShopHeader()) {
        return false
      }
      if (clientEnv.isVivoApp) {
        // 开关关闭，则隐藏头，由上次配置控制
        if (sessionStorage.getItem('navigation_bar_switch') == '0') {
          let preRegex = /^http(s|):\/\/\w+.vivo.com(.cn|)(:\d+|)\/wap\/([a-zA-Z0-9\/]*(product|groupon)\/\d{1,}|search|order\/(quick|recycle)\/confirm|my|activity|recycle).*/
          if (preRegex.test(location.href)) {
            return true
          } else {
            return false
          }
        }
        // else if (clientEnv.isIOSVivoApp) {
        //   return false
        // } else {
        // 响应式头部
        // 注意，这里的正则与官网正则不同，这里仅针对商城配置，官网正则需要关联其他业务，官网Java正则匹配规则，需要在最后的*前加.代表/wap后匹配任意单个或多个任意字符。
        let regex = /^http(s|):\/\/(\w+|)shop.vivo.com(.cn|)(:\d+|)(\/wap|).*/
        //  /^http(s|):\/\/\w+.vivo.com(.cn|)(:\d+|)\/wap\/([a-zA-Z0-9\/]*(product|groupon)\/\d{1,}|search|order\/(quick|recycle)\/confirm|my|activity|recycle).*/
        if (regex.test(location.href)) {
          return true
        } else {
          return false
        }
        // }
      } else if (clientEnv.isWx || clientEnv.isAlipay || clientEnv.isQQ || clientEnv.isvChat || clientEnv.isVHome) {
        return false
      } else {
        return true
      }
    }
  },
  mounted() {
    if (this.listenScroll) {
      this.debounce = debounce(this.handleScroll, 300)
      window.addEventListener('scroll', this.debounce)
    }
    if (window.CSS && CSS.supports && CSS.supports('position', 'sticky')) {
      // 浏览器支持 `position: sticky`
      // 直接使用
    } else {
      // 浏览器不支持 `position: sticky`
      var elements = this.$refs['header-container']
      Stickyfill.add(elements)
    }
  },
  activated() {
    Stickyfill.refreshAll()
  },
  methods: {
    closeMenu() {
      this.isShowMenu = false
    },
    toTop() {
      document.documentElement.scrollIntoView({ behavior: 'smooth', block: 'start' })
    },
    goBack() {
      goBack()
    },
    returnHome() {
      location.href = `${this.linkBase}`
    },
    retry() {
      location.reload()
    },
    handleScroll() {
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      this.$emit('scrolling', scrollTop)
      if (this.isReachBottom()) {
        this.$emit('scrollToLower')
      }
    },
    isReachBottom() {
      const scrollT = document.documentElement.scrollTop || document.body.scrollTop
      const containerH = document.documentElement.offsetHeight
      const eleH = document.querySelector('.v-page-pro').offsetHeight
      // 这里是为了保证由页面有数据变更到在页面无数据时的情况下不调用获取下一页的操作
      if (scrollT) {
        return scrollT + containerH + 100 > eleH
      } else {
        return false
      }
    },
    doPageShare() {
      if (clientEnv.isVivoApp) {
        app.doShare()
      }
    }
  },
  destroyed() {
    this.$osDialog.closeAll()
    this.$dialog.close()
    if (this.listenScroll) {
      window.removeEventListener('scroll', this.debounce)
    }
  }
})
</script>
<style lang="scss" scoped>
.v-page-pro {
  width: 100%;

  .header-container {
    background: #ffff;
    position: sticky;
    top: 0;
    z-index: 200;

    &.vivo-app-no-os-4 .header .icon.share,
    &.vivo-app-no-os-4 .header .icon.search {
      position: absolute;
      right: 100%;
    }

    &.vivo-app-no-os-4 .header .content {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
    }
    .header {
      height: 180px;
      padding: 0 72px;
      flex: 1;
      display: flex;
      justify-content: space-between;
      align-items: center;
      position: relative;

      .icon {
        width: 72px;
        height: 72px;
        color: #000;
        &.back {
          display: inline-flex;
          align-items: center;
          padding-left: 3px;
          .icon-back {
            width: 27px;
            height: 46px;
          }
        }
        &.share {
          @include flex-center;
          position: relative;
          margin-right: 66px;

          .i-share {
            width: 100%;
            height: 100%;
            color: #000000;
          }
          .i-share-v2 {
            width: 54px;
            height: 54px;
            color: #000000;
          }
        }
        &.search {
          @include flex-center;
          position: relative;
          margin-right: 66px;
          .icon-search {
            width: 100%;
            height: 100%;
            color: #000000;
          }
        }

        &.menu {
          display: inline-flex;
          justify-content: center;
          align-items: center;
          .i-menu {
            width: 25px;
            height: 58px;
          }
        }
      }

      .content {
        flex: 1;
      }

      .text {
        // font-size: 45px;
        // line-height: 61px;
        // @include os-font-weight(45, 60);
        // position: relative;
        // &::before {
        //   content: '';
        //   position: absolute;
        //   bottom: 0;
        //   left: 0;
        //   background-color: #f0f0f0;
        //   height: 21px;
        //   width: 100%;
        //   z-index: -1;
        // }
        font-size: 48px;
        padding-left: 18px;
        line-height: 61px;
        @include os-font-weight(48, 60);
        &::before {
          display: none;
        }
      }

      .right {
        flex-shrink: 0;
        display: flex;
        justify-content: space-between;
        position: relative;
      }
    }

    &.dark {
      .header {
        color: #ffffff;

        .icon {
          color: #ffffff;
        }
      }
    }

    // 订单详情头部沉浸式样式
    &.orderDetail {
      background: linear-gradient(178.28deg, #ff2c48 5.53%, #ff4249 29.77%);

      .header {
        color: #ffffff;

        .icon {
          color: #ffffff;
        }
        .text {
          &::before {
            content: '';
            position: absolute;
            bottom: 0;
            left: 0;
            background-color: rgba(240, 240, 240, 0.2);
            height: 21px;
            width: 100%;
            z-index: -1;
          }
        }
      }
    }
  }

  .page-error {
    @include center();
    background: #fafafa;
    width: 100%;
  }

  .v-pending {
    @include center();
    &.lowAndroid {
      margin-top: 45vh;
    }
  }
}

.vivo-dark-mode {
  .v-page-pro .header-container {
    .header {
      color: #ffffff;

      .icon {
        color: #ffffff;
      }

      .text {
        &::before {
          content: '';
          position: absolute;
          bottom: 0;
          left: 0;
          background-color: rgba(255, 255, 255, 0.09);
          height: 21px;
          width: 100%;
          z-index: -1;
        }
      }
    }
  }
}
// OS4.0样式
.vivo-app-no-os-4 .header .content {
  padding: 0 12px;
  flex: none !important;
  &.pd-share {
    max-width: 600px;
  }
  .text {
    font-size: 45px;
    line-height: 61px;
    padding-left: 0px;
    @include os-font-weight(45, 60);
    position: relative;
    &::before {
      display: inline-block;
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      background-color: #f0f0f0;
      height: 21px;
      width: 100%;
      z-index: -1;
    }
  }
}
</style>
